export default __webpack_public_path__ + "dcb0c49216fe6ddaf15471e53847acc1.jpg";